import { addDays, isBefore, startOfDay } from 'app/lib/date';
import { LoanStatus, type Loan } from 'app/types/loan';

const QUALIFYING_LOAN_STATUSES = new Set<LoanStatus>([LoanStatus.Accepted, LoanStatus.Returned, LoanStatus.Completed]);

function getQualifyingLoanDate(loan: Loan): Date | undefined {
  const date = new Date(loan.accepted ?? loan.returned ?? loan.updatedAt ?? loan.createdAt);
  return Number.isNaN(date.getTime()) ? undefined : date;
}

export function getFirstQualifyingLoanDate(loans: Loan[]): Date | undefined {
  return loans
    .filter((loan) => QUALIFYING_LOAN_STATUSES.has(loan.status))
    .map(getQualifyingLoanDate)
    .filter((date): date is Date => date !== undefined)
    .sort((a, b) => a.getTime() - b.getTime())[0];
}

export function getFirstLoanDiscountDeadline(loans: Loan[]): Date | undefined {
  const firstLoanDate = getFirstQualifyingLoanDate(loans);
  return firstLoanDate ? addDays(startOfDay(firstLoanDate), 2) : undefined;
}

export function getCreditUsedAt(creditPlanExpiredAt: string | null | undefined): Date | undefined {
  if (!creditPlanExpiredAt) return undefined;

  const expiredAt = new Date(creditPlanExpiredAt);
  return Number.isNaN(expiredAt.getTime()) ? undefined : expiredAt;
}

export function getLoanDiscountDeadline(creditPlanExpiredAt: string | null | undefined): Date | undefined {
  const creditUsedAt = getCreditUsedAt(creditPlanExpiredAt);
  return creditUsedAt ? addDays(creditUsedAt, 2) : undefined;
}

export function isLoanDiscountActive(deadline: Date | undefined, today = new Date()): boolean {
  return deadline !== undefined && !isBefore(startOfDay(deadline), startOfDay(today));
}
